import { render, staticRenderFns } from "./HistoricalDataStacked.vue?vue&type=template&id=dbc043ee&"
import script from "./HistoricalDataStacked.vue?vue&type=script&lang=js&"
export * from "./HistoricalDataStacked.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalDataStacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports